import React, { Fragment, useEffect, useState } from 'react';
import { Container, Row, Col } from 'shards-react';
import '../../assets/style.css';

import { useTranslation } from 'react-i18next';
import useForm from './useForm';
import { Bar, Line, Pie } from 'react-chartjs-2';
import VisibilityIcon from '@material-ui/icons/Visibility';

import { Card, FormControl, FormControlLabel, FormLabel, LinearProgress, Radio, RadioGroup, Slider } from '@material-ui/core';
import Input from '../../components/UI/Input/Input';
import { getFile } from '@opu/utils';
import { useHistory } from 'react-router-dom';
import PageTitle from '../../components/common/PageTitle';
import { now } from 'moment';
import { DatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import MomentUtils from '@date-io/moment';
import moment from 'moment';
import zIndex from '@material-ui/core/styles/zIndex';
const Dashboard = (props) => {
  const { establishmentUser } = props;
  const history = useHistory();
  const {
    loading,
    headerStatistics,
    year,
    setYear,
    connectedStudents,
    connectedStudentsControls,
    setConnectedStudentsControls,
    createdStudents,
    createdStudentsControls,
    setCreatedStudentsControls,
    todaysTopTenBooks,
    selectedMonthTopTenBooks,
    selectedYearTopTenBooks,
    booksControls,
    setBooksControls,
    parseBookNbrViews,
  } = useForm();
  const { t, i18n } = useTranslation();

  const detailsBook = (id) => {
    history.push({
      pathname: '/book/details',
      params: {
        id: id,
      },
    });
  };

  const backgroundColor = [
    '#095871',
    '#2a677f',
    '#41768c',
    '#56859a',
    '#6a95a9',
    '#7ea5b7',
    '#92b5c6',
    '#a6c5d5',
    '#bad6e4',
    '#0093f7',
    '#419af6',
    '#5ea2f6',
    '#73aaf5',
    '#86b2f4',
    '#97b9f4',
    '#a6c2f3',
    '#b5caf2',
    '#c3d2f1',
    '#fcba2d',
    '#fabd43',
    '#f8bf55',
    '#f5c266',
    '#efc785',
    '#ecca94',
    '#e8cca3',
    '#e3cfb2',
  ];

  const currentYear = new Date(Date.now()).getFullYear();
  function valuetext(value) {
    return `${currentYear}`;
  }
  return (
    <>
      {(headerStatistics.loading ||
        connectedStudentsControls.loading ||
        createdStudentsControls.loading ||
        booksControls.loading) && <LinearProgress />}

      <Container fluid className="main-content-container px-4 pb-4">
        <Row noGutters className="page-header py-4">
          <PageTitle sm="4" title={t('label.statistics')} subtitle={t('label.dashboard')} className="text-sm-left" />
        </Row>
        <Row style={{ marginTop: '10px' }} className="d-flex justify-content-between">
          {!establishmentUser && (
            <div className="col-lg mb-4 col-sm-6 col-md-6">
              <div className="stats-small stats-small--1 card card-small">
                <div className="p-0 d-flex card-body">
                  <div className="d-flex flex-column m-auto">
                    <div className="stats-small__data text-center">
                      <span className="stats-small__label text-uppercase">{t('label.establishmentCount')}</span>
                      <h6 className="stats-small__value count my-3">{headerStatistics.establishmentsCount}</h6>
                    </div>
                  </div>
                  <canvas height="127" className="stats-small-0y9jxQsE- chartjs-render-monitor" width="319"></canvas>
                </div>
              </div>
            </div>
          )}

          <div className="col-lg mb-4 col-sm-6 col-md-6">
            <div className="stats-small stats-small--1 card card-small">
              <div className="p-0 d-flex card-body">
                <div className="d-flex flex-column m-auto">
                  <div className="stats-small__data text-center">
                    <span className="stats-small__label text-uppercase">{t('label.activatedStudentsCount')}</span>
                    <h6 className="stats-small__value count my-3">{headerStatistics.studentsCountPerActivationStatus.true}</h6>
                  </div>
                </div>
                <canvas height="127" className="stats-small-0y9jxQsE- chartjs-render-monitor" width="319"></canvas>
              </div>
            </div>
          </div>

          <div className="col-lg mb-4 col-sm-6 col-md-6">
            <div className="stats-small stats-small--1 card card-small">
              <div className="p-0 d-flex card-body">
                <div className="d-flex flex-column m-auto">
                  <div className="stats-small__data text-center">
                    <span className="stats-small__label text-uppercase">{t('label.deactivatedStudentsCount')}</span>
                    <h6 className="stats-small__value count my-3">{headerStatistics.studentsCountPerActivationStatus.false}</h6>
                  </div>
                </div>
                <canvas height="127" className="stats-small-0y9jxQsE- chartjs-render-monitor" width="319"></canvas>
              </div>
            </div>
          </div>

          <div className="col-lg mb-4 col-sm-6 col-md-6">
            <div className="stats-small stats-small--1 card card-small">
              <div className="p-0 d-flex card-body">
                <div className="d-flex flex-column m-auto">
                  <div className="stats-small__data text-center">
                    <span className="stats-small__label text-uppercase">{t('label.todaysConnectedStudentsCount')}</span>
                    <h6 className="stats-small__value count my-3">{headerStatistics.todaysConnectedStudentsCount}</h6>
                  </div>
                </div>
                <canvas height="127" className="stats-small-0y9jxQsE- chartjs-render-monitor" width="319"></canvas>
              </div>
            </div>
          </div>
          {!establishmentUser && (
            <div className="col-lg mb-4 col-sm-6 col-md-6">
              <div className="stats-small stats-small--1 card card-small">
                <div className="p-0 d-flex card-body">
                  <div className="d-flex flex-column m-auto">
                    <div className="stats-small__data text-center">
                      <span className="stats-small__label text-uppercase">{t('label.bookCount')}</span>
                      <h6 className="stats-small__value count my-3">{headerStatistics.booksCount}</h6>
                    </div>
                  </div>
                  <canvas height="127" className="stats-small-0y9jxQsE- chartjs-render-monitor" width="319"></canvas>
                </div>
              </div>
            </div>
          )}
          {establishmentUser && (
            <>
              <div className="col-lg mb-4 col-sm-6 col-md-6">
                <div className="stats-small stats-small--1 card card-small">
                  <div className="p-0 d-flex card-body">
                    <div className="d-flex flex-column m-auto">
                      <div className="stats-small__data text-center">
                        <span className="stats-small__label text-uppercase">
                          {t('label.todaysBookConsultationsCount')}
                        </span>
                        <h6 className="stats-small__value count my-3">
                          {headerStatistics.todaysBookConsultationsCount ?? 0}
                        </h6>
                      </div>
                    </div>
                    <canvas height="127" className="stats-small-0y9jxQsE- chartjs-render-monitor" width="319"></canvas>
                  </div>
                </div>
              </div>
              <div className="col-lg mb-4 col-sm-6 col-md-6">
                <div className="stats-small stats-small--1 card card-small">
                  <div className="p-0 d-flex card-body">
                    <div className="d-flex flex-column m-auto">
                      <div className="stats-small__data text-center">
                        <span className="stats-small__label text-uppercase">
                          {t('label.bookConsultationsCount')}
                        </span>
                        <h6 className="stats-small__value count my-3">
                          {headerStatistics.bookConsultationsCount ?? 0}
                        </h6>
                      </div>
                    </div>
                    <canvas height="127" className="stats-small-0y9jxQsE- chartjs-render-monitor" width="319"></canvas>
                  </div>
                </div>
              </div>
            </>
          )}
        </Row>
        <Row style={{ marginTop: '10px' }} className="d-flex justify-content-center">
          <Col className="col-lg-9 mb-4 col-sm-6 col-md-6">
            <div className=" card ">
              <div className="row d-flex card-body">
                <h5 className="card-title col-lg-12 text-center">
                  {(connectedStudentsControls.displayBy === 'day' && t('label.connectedStudentsCountPerDayInMonth')) ||
                    (connectedStudentsControls.displayBy === 'month' && t('label.connectedStudentsCountPerMonthInYear')) ||
                    (connectedStudentsControls.displayBy === 'year' && t('label.connectedStudentsCountPerYearForLastXYears'))}
                </h5>
                <Col md="2" className="pt-2 ml-4">
                  <MuiPickersUtilsProvider utils={MomentUtils} moment={moment}>
                    <DatePicker
                      inputProps={{ className: 'text-center' }}
                      disabled={connectedStudentsControls.displayBy === 'year'}
                      variant="inline"
                      openTo="month"
                      views={connectedStudentsControls.displayBy === 'day' ? ['year', 'month'] : ['year']}
                      value={connectedStudentsControls.date}
                      onChange={(date) =>
                        setConnectedStudentsControls({
                          ...connectedStudentsControls,
                          date: date.format('YYYY-MM-DD'),
                        })
                      }
                    />
                  </MuiPickersUtilsProvider>
                </Col>
                <Col md="6" className="align-middle">
                  <FormControl component="fieldset">
                    <FormLabel component="legend"></FormLabel>
                    <RadioGroup
                      row
                      aria-label="date-filter"
                                            name="row-radio-buttons-group"
                      onChange={(e) => {
                        setConnectedStudentsControls({
                          ...connectedStudentsControls,
                          displayBy: e.target.value,
                        });
                      }}
                      value={connectedStudentsControls.displayBy}
                    >
                      <FormControlLabel value="day" control={<Radio />} label={t('label.days')} />
                      <FormControlLabel value="month" control={<Radio />} label={t('label.monthss')} />
                      <FormControlLabel value="year" control={<Radio />} label={t('label.years')} />
                    </RadioGroup>
                  </FormControl>{' '}
                </Col>
                <div className="col-lg-12">
                  {true && (
                    <Bar
                      type=""
                      data={{
                        labels:
                          (connectedStudentsControls.displayBy === 'day' && connectedStudents.countPerDayInMonth.labels) ||
                          (connectedStudentsControls.displayBy === 'month' && connectedStudents.countPerMonthInYear.labels) ||
                          (connectedStudentsControls.displayBy === 'year' && connectedStudents.countPerYearForLastXYears.labels),
                        datasets: [
                          {
                            data:
                              (connectedStudentsControls.displayBy === 'day' && connectedStudents.countPerDayInMonth.data) ||
                              (connectedStudentsControls.displayBy === 'month' && connectedStudents.countPerMonthInYear.data) ||
                              (connectedStudentsControls.displayBy === 'year' &&
                                connectedStudents.countPerYearForLastXYears.data),
                            backgroundColor: backgroundColor,
                            // borderColor: ['rgba(53, 152, 219, 1)'],
                            borderWidth: 1,
                          },
                        ],
                      }}
                      height={400}
                      options={{
                        maintainAspectRatio: false,
                        plugins: {
                          legend: {
                            display: false, //This will do the task
                          },
                        },
                      }}
                    />
                  )}
                </div>
              </div>
            </div>
          </Col>

          <Col className="col-lg-3 mb-4 col-sm-6 col-md-6 d-flex ">
            <div className=" card ">
              <div className="row d-flex card-body" style={{ height: '100%' }}>
                <h5 className="card-title col-lg-12 text-center">{t('label.studentsCountPerGender')}</h5>

                <div className="col-lg-12">
                  {true && (
                    <Pie
                      type=""
                      data={{
                        labels: headerStatistics.studentsCountPerGender.labels,
                        datasets: [
                          {
                            label: 'Number Of Students Per Gender ',
                            data: headerStatistics.studentsCountPerGender.data,
                            backgroundColor: ['#34a6f3', '#f50057'],
                            borderColor: ['rgba(53, 152, 219, 1)'],
                            borderWidth: 1,
                          },
                        ],
                      }}
                      height={400}
                      options={{
                        maintainAspectRatio: false,
                        plugins: {},
                      }}
                    />
                  )}
                </div>
              </div>
            </div>
          </Col>

          <div className="col-lg-9 mb-4 col-sm-6 col-md-6 d-flex">
            <div className=" card ">
              <div className="row d-flex card-body">
                <h5 className="card-title col-lg-12 text-center">
                  {(createdStudentsControls.displayBy === 'day' && t('label.createdStudentsCountPerDayInMonth')) ||
                    (createdStudentsControls.displayBy === 'month' && t('label.createdStudentsCountPerMonthInYear')) ||
                    (createdStudentsControls.displayBy === 'year' && t('label.createdStudentsCountPerYearForLastXYears'))}
                </h5>
                <Col md="2" className="pt-2 ml-4">
                  <MuiPickersUtilsProvider utils={MomentUtils} moment={moment}>
                    <DatePicker
                      inputProps={{ className: 'text-center' }}
                      disabled={createdStudentsControls.displayBy === 'year'}
                      variant="inline"
                      openTo="month"
                      views={createdStudentsControls.displayBy === 'day' ? ['year', 'month'] : ['year']}
                      value={createdStudentsControls.date}
                      onChange={(date) =>
                        setCreatedStudentsControls({
                          ...createdStudentsControls,
                          date: date.format('YYYY-MM-DD'),
                        })
                      }
                    />
                  </MuiPickersUtilsProvider>
                </Col>
                <Col md="6" className="align-middle">
                  <FormControl component="fieldset">
                    <FormLabel component="legend"></FormLabel>
                    <RadioGroup
                      row
                      aria-label="date-filter"
                                            name="row-radio-buttons-group"
                      onChange={(e) => {
                        setCreatedStudentsControls({
                          ...createdStudentsControls,
                          displayBy: e.target.value,
                        });
                      }}
                      value={createdStudentsControls.displayBy}
                    >
                      <FormControlLabel value="day" control={<Radio />} label={t('label.days')} />
                      <FormControlLabel value="month" control={<Radio />} label={t('label.monthss')} />
                      <FormControlLabel value="year" control={<Radio />} label={t('label.years')} />
                    </RadioGroup>
                  </FormControl>{' '}
                </Col>
                <div className="col-lg-12"></div>
                <div className="col-lg-12">
                  {true && (
                    <Bar
                      type=""
                      data={{
                        labels:
                          (createdStudentsControls.displayBy === 'day' && createdStudents.countPerDayInMonth.labels) ||
                          (createdStudentsControls.displayBy === 'month' && createdStudents.countPerMonthInYear.labels) ||
                          (createdStudentsControls.displayBy === 'year' && createdStudents.countPerYearForLastXYears.labels),
                        datasets: [
                          {
                            data:
                              (createdStudentsControls.displayBy === 'day' && createdStudents.countPerDayInMonth.data) ||
                              (createdStudentsControls.displayBy === 'month' && createdStudents.countPerMonthInYear.data) ||
                              (createdStudentsControls.displayBy === 'year' && createdStudents.countPerYearForLastXYears.data),
                            backgroundColor: backgroundColor,
                            // borderColor: ['rgba(53, 152, 219, 1)'],
                            borderWidth: 1,
                          },
                        ],
                      }}
                      height={400}
                      options={{
                        maintainAspectRatio: false,
                        plugins: {
                          legend: {
                            display: false, //This will do the task
                          },
                        },
                      }}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
          <Col className="col-lg-3 mb-4 col-sm-6 col-md-6 d-flex ">
            <div className=" card ">
              <div className="row d-flex card-body" style={{ height: '100%' }}>
                <h5 className="card-title col-lg-12 text-center">{t('label.studentsCountPerLevel')}</h5>

                <div className="col-lg-12">
                  {true && (
                    <Pie
                      type=""
                      data={{
                        labels: headerStatistics.studentsCountPerLevel.labels.map((element) => {
                          console.log('Anas ya anas :', element);
                          return t('personal-information.chart.' + element);
                        }),
                        datasets: [
                          {
                            label: 'Number Of Students Per Level ',
                            data: headerStatistics.studentsCountPerLevel.data,
                            backgroundColor: backgroundColor,
                            borderColor: ['rgba(53, 152, 219, 1)'],
                            borderWidth: 1,
                          },
                        ],
                      }}
                      height={400}
                      options={{
                        maintainAspectRatio: false,
                        plugins: {},
                      }}
                    />
                  )}
                </div>
              </div>
            </div>
          </Col>
          <Container fluid>
              <Row>
                {booksControls.displayBy === 'day' && (
                  <div className="col-12 mb-4   ">
                    <div className=" card ">
                      <div className="row d-flex card-body">
                        <h5 className="card-title col-lg-12 text-center">{t('label.topTenViewedBooks')}</h5>

                        <Col md="2" className="pt-2 ml-4">
                          <MuiPickersUtilsProvider utils={MomentUtils} moment={moment}>
                            <DatePicker
                              inputProps={{ className: 'text-center' }}
                              disabled={true}
                              variant="inline"
                              openTo="month"
                              views={['day', 'year', 'month']}
                            />
                          </MuiPickersUtilsProvider>
                        </Col>
                        <Col md="6" className="align-middle">
                          <FormControl component="fieldset">
                            <FormLabel component="legend"></FormLabel>
                            <RadioGroup
                              row
                              aria-label="date-filter"
                                                            name="row-radio-buttons-group"
                              onChange={(e) => {
                                setBooksControls({
                                  ...booksControls,
                                  displayBy: e.target.value,
                                });
                              }}
                              value={booksControls.displayBy}
                            >
                              <FormControlLabel value="day" control={<Radio />} label={t('label.days')} />
                              <FormControlLabel value="month" control={<Radio />} label={t('label.monthss')} />
                              <FormControlLabel value="year" control={<Radio />} label={t('label.years')} />
                            </RadioGroup>
                          </FormControl>{' '}
                        </Col>

                        <div className="col-lg-12"></div>
                      </div>
                      <div className="row d-flex    justify-content-center pl-4">
                        {todaysTopTenBooks.length === 0 && (
                          <div>
                            <h2 className="card-title col-lg-12 text-center mb-5">
                              Aucun Top 10 livres n'a été trouvé pour aujourd'hui
                            </h2>
                          </div>
                        )}
                        {todaysTopTenBooks.map(
                          (book, index) =>
                            index < 5 && (
                              <div className="col-2" style={{ marginRight: '20px' }} onClick={() => detailsBook(book.id)}>
                                <div style={{ cursor: 'pointer' }}>
                                  <img
                                    className="card d-flex justify-content-center"
                                    width="228"
                                    height="350"
                                    src={getFile('book', book.cover)}
                                    alt="book-cover"
                                  />
                                  <div className="card-title col-lg-12 text-center pt-2 ">
                                    {parseBookNbrViews(book.nbrViews)}&nbsp;
                                    <VisibilityIcon className="view-eye-icon" />
                                    <h6>{book.title}</h6>
                                  </div>
                                </div>
                              </div>
                            )
                        )}
                      </div>
                      <div className="row d-flex    justify-content-center pl-4">
                        {todaysTopTenBooks.map(
                          (book, index) =>
                            index > 4 && (
                              <div className="col-2" style={{ marginRight: '20px' }} onClick={() => detailsBook(book.id)}>
                                <div style={{ cursor: 'pointer' }}>
                                  <img
                                    className="card d-flex justify-content-center"
                                    width="228"
                                    height="350"
                                    src={getFile('book', book.cover)}
                                    alt="book-cover"
                                  />
                                  <div className="card-title col-lg-12 text-center pt-2 ">
                                    {parseBookNbrViews(book.nbrViews)}&nbsp;
                                    <VisibilityIcon className="view-eye-icon" />
                                    <h6>{book.title}</h6>
                                  </div>
                                </div>
                              </div>
                            )
                        )}
                      </div>
                    </div>
                  </div>
                )}

                {booksControls.displayBy === 'month' && (
                  <div className="col-lg-12 mb-4 col-sm-6 col-md-6">
                    <div className=" card ">
                      <div className="row d-flex card-body">
                        <h5 className="card-title col-lg-12 text-center">{t('label.monthtopTenViewedBooks')}</h5>

                        <Col md="2" className="pt-2 ml-4">
                          <MuiPickersUtilsProvider utils={MomentUtils} moment={moment}>
                            <DatePicker
                              inputProps={{ className: 'text-center' }}
                              variant="inline"
                              openTo="month"
                              views={['year', 'month']}
                              value={booksControls.monthYear}
                              onChange={(date) =>
                                setBooksControls({
                                  ...booksControls,
                                  monthYear: {
                                    month: moment(date).month(),
                                    year: moment(date).year(),
                                  },
                                })
                              }
                            />
                          </MuiPickersUtilsProvider>
                        </Col>
                        <Col md="6" className="align-middle">
                          <FormControl component="fieldset">
                            <FormLabel component="legend"></FormLabel>
                            <RadioGroup
                              row
                              aria-label="date-filter"
                                                            name="row-radio-buttons-group"
                              onChange={(e) => {
                                setBooksControls({
                                  ...booksControls,
                                  displayBy: e.target.value,
                                });
                              }}
                              value={booksControls.displayBy}
                            >
                              <FormControlLabel value="day" control={<Radio />} label={t('label.days')} />
                              <FormControlLabel value="month" control={<Radio />} label={t('label.monthss')} />
                              <FormControlLabel value="year" control={<Radio />} label={t('label.years')} />
                            </RadioGroup>
                          </FormControl>{' '}
                        </Col>

                        <div className="col-lg-12"></div>
                      </div>
                      <div className="row d-flex    justify-content-center pl-4">
                        {selectedMonthTopTenBooks.length === 0 && (
                          <div>
                            <h2 className="card-title col-lg-12 text-center mb-5">Aucun livre trouvé pour ce mois sélectionné</h2>
                          </div>
                        )}
                        {selectedMonthTopTenBooks.map(
                          (book, index) =>
                            index < 5 && (
                              <div className="col-2" style={{ marginRight: '20px' }} onClick={() => detailsBook(book.id)}>
                                <div style={{ cursor: 'pointer' }}>
                                  <img
                                    className="card d-flex justify-content-center"
                                    width="228"
                                    height="350"
                                    src={getFile('book', book.cover)}
                                    alt="book-cover"
                                  />
                                  <div className="card-title col-lg-12 text-center pt-2 ">
                                    {parseBookNbrViews(book.nbrViews)}&nbsp;
                                    <VisibilityIcon className="view-eye-icon" />
                                    <h6>{book.title}</h6>
                                  </div>
                                </div>
                              </div>
                            )
                        )}
                      </div>
                      <div className="row d-flex    justify-content-center pl-4">
                        {selectedMonthTopTenBooks.map(
                          (book, index) =>
                            index > 4 && (
                              <div className="col-2" style={{ marginRight: '20px' }} onClick={() => detailsBook(book.id)}>
                                <div style={{ cursor: 'pointer' }}>
                                  <img
                                    className="card d-flex justify-content-center"
                                    width="228"
                                    height="350"
                                    src={getFile('book', book.cover)}
                                    alt="book-cover"
                                  />
                                  <div className="card-title col-lg-12 text-center pt-2 ">
                                    {parseBookNbrViews(book.nbrViews)}&nbsp;
                                    <VisibilityIcon className="view-eye-icon" />
                                    <h6>{book.title}</h6>
                                  </div>
                                </div>
                              </div>
                            )
                        )}
                      </div>
                    </div>
                  </div>
                )}

                {booksControls.displayBy === 'year' && (
                  <div className="col-lg-12 mb-4 col-sm-6 col-md-6">
                    <div className=" card ">
                      <div className="row d-flex card-body">
                        <h5 className="card-title col-lg-12 text-center">{t('label.yeartopTenViewedBooks')}</h5>
                        <Col md="2" className="pt-2 ml-4">
                          <MuiPickersUtilsProvider utils={MomentUtils} moment={moment}>
                            <DatePicker
                              inputProps={{ className: 'text-center' }}
                              variant="inline"
                              openTo="month"
                              views={['year']}
                              value={`${booksControls.year}`}
                              onChange={(date) =>
                                setBooksControls({
                                  ...booksControls,
                                  year: moment(date).year(),
                                })
                              }
                            />
                          </MuiPickersUtilsProvider>
                        </Col>

                        <Col md="6" className="align-middle">
                          <FormControl component="fieldset">
                            <FormLabel component="legend"></FormLabel>
                            <RadioGroup
                              row
                              aria-label="date-filter"
                                                            name="row-radio-buttons-group"
                              onChange={(e) => {
                                setBooksControls({
                                  ...booksControls,
                                  displayBy: e.target.value,
                                });
                              }}
                              value={booksControls.displayBy}
                            >
                              <FormControlLabel value="day" control={<Radio />} label={t('label.days')} />
                              <FormControlLabel value="month" control={<Radio />} label={t('label.monthss')} />
                              <FormControlLabel value="year" control={<Radio />} label={t('label.years')} />
                            </RadioGroup>
                          </FormControl>{' '}
                        </Col>
                        <div className="col-lg-12"></div>
                      </div>
                      <div className="row d-flex    justify-content-center pl-4">
                        {selectedYearTopTenBooks.length === 0 && (
                          <div>
                            <h2 className="card-title col-lg-12 text-center mb-5">
                              Aucun livre trouvé pour cette année sélectionnée
                            </h2>
                          </div>
                        )}
                        {selectedYearTopTenBooks.map(
                          (book, index) =>
                            index < 5 && (
                              <div className="col-2" style={{ marginRight: '20px' }} onClick={() => detailsBook(book.id)}>
                                <div style={{ cursor: 'pointer' }}>
                                  <img
                                    className="card d-flex justify-content-center"
                                    width="228"
                                    height="350"
                                    src={getFile('book', book.cover)}
                                    alt="book-cover"
                                  />
                                  <div className="card-title col-lg-12 text-center pt-2 ">
                                    {parseBookNbrViews(book.nbrViews)}&nbsp;
                                    <VisibilityIcon className="view-eye-icon" />
                                    <h6>{book.title}</h6>
                                  </div>
                                </div>
                              </div>
                            )
                        )}
                      </div>
                      <div className="row d-flex    justify-content-center pl-4">
                        {selectedYearTopTenBooks.map(
                          (book, index) =>
                            index > 4 && (
                              <div className="col-2" style={{ marginRight: '20px' }} onClick={() => detailsBook(book.id)}>
                                <div style={{ cursor: 'pointer' }}>
                                  <img
                                    className="card d-flex justify-content-center"
                                    width="228"
                                    height="350"
                                    src={getFile('book', book.cover)}
                                    alt="book-cover"
                                  />
                                  <div className="card-title col-lg-12 text-center pt-2 ">
                                    {parseBookNbrViews(book.nbrViews)}&nbsp;
                                    <VisibilityIcon className="view-eye-icon" />
                                    <h6>{book.title}</h6>
                                  </div>
                                </div>
                              </div>
                            )
                        )}
                      </div>
                    </div>
                  </div>
                )}
              </Row>
            </Container>
        </Row>
      </Container>
    </>
  );
};

export default Dashboard;
